import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as Annotation from 'highcharts/modules/annotations';
Annotation(Highcharts);

export interface PlotBands {
  from: number,
  to: number,
  color: string,
  id?: string,
  zIndex?: number,
}

export interface Respirations {
  x: number,
  y: number,
}

export interface Motions {
  [0]: number;
  [1]: number;
}

export interface AnnotationLabels {
  point: {
    x: number,
    y: number,
    yAxis: number,
    xAxis: number,
  },
  useHTML: boolean,
  shape: 'circle',
  format: string,
}

/**
 * Generated class for the EventGraphComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'event-graph',
  templateUrl: 'event-graph.html'
})
export class EventGraphComponent implements OnInit, AfterViewInit {

  @Input() plotBands: PlotBands[];
  @Input() respirations: Respirations[];
  @Input() motions: Motions[];
  @Input() annotationLabels: AnnotationLabels[];
  chartId: string;

  constructor() {
    console.log('Hello EventGraphComponent Component');
  }

  ngOnInit() {
    this.chartId = 'event-graph-' + Math.random().toString(36).slice(-8);
  }

  ngAfterViewInit() {  

    Highcharts.chart(this.chartId, {

      title: {
        text: '',
      },
      credits: {
        enabled: false
      },
      xAxis: {
          tickInterval: 1, // 1時間ごとに表示
          labels: {
              format: `{value}時`
          },
          plotBands: this.plotBands,
      },  
      tooltip: {
          style: {
              width: '250px'
          },
          useHTML: true,
          formatter: function() {
            return `${this.point.series.name}<br>${this.x}時: ${this.y}`
          },
      },
      yAxis: [{
          max: 100,
          labels: {
              enabled: false
          },
          title: {
              text: ''
          },
          gridLineColor: 'rgba(0, 0, 0, 0)'
      }, {
          allowDecimals: false,
          max: 15,
          labels: {
              style: {
                  color: Highcharts.getOptions().colors[2]
              }
          },
          title: {
              text: '',
              style: {
                  color: Highcharts.getOptions().colors[2]
              }
          },
          opposite: true,
          gridLineWidth: 0
      }],
  
      plotOptions: {
          series: {
              marker: {
                  enabled: false,
                  symbol: 'circle',
                  radius: 2
              },
              fillOpacity: 0.5,
          },
      },
  
      series: [
        {
          type: 'spline',
          id: 'respirations',
          dashStyle: 'dash',
          name: '呼吸数',
          data: this.respirations,
        },
        {
          name: '10分間隔の体動エリアグラフ',
          id: 'motions',
          type: 'area',
          data: this.motions,
          color: '#ffb143',
          lineWidth: 0,
        },
      ],
      annotations: [{
        labels: this.annotationLabels,
        labelOptions: {
          borderRadius: 5,
          backgroundColor: '#FFCDD2',
          borderWidth: 1,
          borderColor: '#FFCDD2'
        }
      }]
    })
  }

}



// WEBPACK FOOTER //
// ./src/components/event-graph/event-graph.ts